import { render } from "./CompResultadoAgregado.vue?vue&type=template&id=744c999e"
import script from "./CompResultadoAgregado.vue?vue&type=script&lang=js"
export * from "./CompResultadoAgregado.vue?vue&type=script&lang=js"

import "./CompResultadoAgregado.vue?vue&type=style&index=0&id=744c999e&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__